import { getApiClient } from './client'

// --- Mail Types ---

export function listTypes(holderType, holderId) {
  return getApiClient()
    .get(`/mail/${holderType}/${holderId}/types`)
    .then((res) => res.data.data ?? res.data ?? [])
}

// --- Mail Templates ---

export function listTemplates(holderType, holderId, params = {}) {
  return getApiClient()
    .get(`/mail/${holderType}/${holderId}/templates`, { params })
    .then((res) => {
      const payload = res.data.data ?? res.data
      if (payload && typeof payload === 'object' && !Array.isArray(payload) && Array.isArray(payload.data)) {
        return payload // { data: [], meta: {} }
      }
      if (Array.isArray(payload)) {
        return { data: payload, meta: { total: payload.length } }
      }
      return { data: [], meta: { total: 0 } }
    })
}

export function getTemplate(holderType, holderId, templateId) {
  return getApiClient()
    .get(`/mail/${holderType}/${holderId}/templates/${templateId}`)
    .then((res) => res.data.data ?? res.data ?? {})
}

export function createTemplate(holderType, holderId, data) {
  return getApiClient()
    .post(`/mail/${holderType}/${holderId}/templates`, data)
    .then((res) => res.data.data ?? res.data ?? {})
}

export function updateTemplate(holderType, holderId, templateId, data) {
  return getApiClient()
    .put(`/mail/${holderType}/${holderId}/templates/${templateId}`, data)
    .then((res) => res.data.data ?? res.data ?? {})
}

export function deleteTemplate(holderType, holderId, templateId) {
  return getApiClient().delete(`/mail/${holderType}/${holderId}/templates/${templateId}`)
}

export function previewTemplate(holderType, holderId, data) {
  return getApiClient()
    .post(`/mail/${holderType}/${holderId}/templates/preview`, data)
    .then((res) => res.data.data ?? res.data ?? {})
}
